export default "__VITE_ASSET__bc31abf9__"